import React, { FC } from 'react'
import Container from 'react-bootstrap/Container'

import {
    companyNameFull,
    preferedName,
    dataPortalTitle
} from '../../assets/i18n/i18n'

import PageTitle from '../PageTitle'

const TermsAndConditions: FC = () => {
    return (
        <section className='content'>
            <Container>
                <PageTitle displayName="Member Terms and Conditions" />

                <h1 className='headerText h2'>Member Terms and Conditions</h1>

                <p>
                    <strong>Effective Date:</strong> September 24, 2026
                    <br />
                    <strong>Date Last Updated:</strong> September 24, 2026
                </p>

                <h2 className='h3'>1. Acceptance of Terms</h2>

                <p>
                    By clicking &quot;I Agree,&quot; registering for, accessing,
                    or using the ConnectID {preferedName} {dataPortalTitle}{' '}
                    (&quot;Portal&quot;), provided by {companyNameFull} and
                    powered by technology partners HealthLX and TESCHGlobal
                    (collectively, &quot;we,&quot; &quot;us,&quot; or
                    &quot;our&quot;), you acknowledge that you have read and
                    agree to be bound by these Terms and Conditions
                    (&quot;terms&quot;), the Privacy Notice, and the Cookie
                    Policy, each as may be updated from time to time. Your
                    electronic acceptance constitutes your legally binding
                    electronic signature.
                </p>

                <h2 className='h3'>2. Portal Use &amp; Account Security</h2>

                <ul>
                    <li>
                        You may use this Portal solely to access your{' '}
                        {companyNameFull} plan details, Explanation of Benefits
                        (EOBs), coverage information, and personal health records.
                    </li>

                    <li>
                        You are responsible for keeping your login credentials
                        secure. Notify {companyNameFull} support immediately of
                        any unauthorized access or breach.
                    </li>

                    <li>
                        You agree not to misrepresent your identity, impersonate
                        others, or use the Portal for any unlawful purpose.
                    </li>

                    <li>
                        Subject to these Terms, we grant you a limited, personal,
                        non-exclusive, non-transferable, revocable license to
                        access and use the Portal solely for purposes related to
                        your health plan benefits and coverage.
                    </li>

                    <li>
                        You are responsible for maintaining the confidentiality
                        of your username, password, multifactor authentication
                        credentials, and any other account credentials.
                    </li>

                    <li>
                        You are responsible for all activity occurring under your
                        account unless you promptly report unauthorized use.
                    </li>

                    <li>
                        You shall not:
                        <ul>
                            <li>
                                attempt to access another user&apos;s account or
                                information;
                            </li>
                            <li>
                                use automated means to access the Portal;
                            </li>
                            <li>
                                interfere with Portal operations;
                            </li>
                            <li>
                                circumvent security controls;
                            </li>
                            <li>
                                reverse engineer or attempt to extract source
                                code from the Portal.
                            </li>
                        </ul>
                    </li>

                    <li>
                        We may suspend, restrict, or terminate access to the
                        Portal at any time for security, maintenance, legal,
                        operational, or compliance reasons.
                    </li>
                </ul>

                <h2 className='h3'>3. Intellectual Property</h2>

                <p>
                    All materials, interfaces, and software on this Portal are
                    owned by {companyNameFull} or its technology licensors
                    (HealthLX and TESCHGlobal) and are protected by applicable
                    intellectual property laws.
                </p>

                <h2 className='h3'>
                    4. Disclaimers &amp; Limitation of Liability
                </h2>

                <ul>
                    <li>
                        The Portal is provided on an &quot;AS IS&quot; and
                        &quot;AS AVAILABLE&quot; basis.
                    </li>

                    <li>
                        To the fullest extent permitted by law, {companyNameFull}{' '}
                        and its technology partners, HealthLX and TESCHGlobal,
                        shall not be liable for any indirect, incidental,
                        consequential, special, exemplary, or punitive damages
                        arising from or relating to use of the Portal, even if
                        advised of the possibility of such damages.
                    </li>

                    <li>
                        Information displayed through the Portal is provided for
                        convenience only. Official plan documents, insurer
                        records, administrator records, and applicable benefit
                        determinations shall control in the event of any
                        discrepancy.
                    </li>
                </ul>

                <h2 className='h3'>5. Governing Law</h2>

                <p>
                    These Terms are governed by the laws of the State of
                    Wisconsin, with exclusive jurisdiction in the courts of
                    Ozaukee County, WI.
                </p>
            </Container>
        </section>
    )
}

export default TermsAndConditions